import { useState, useEffect } from 'react';
import { supabase } from '../lib/supabase';
import type { Company } from '../types/company';

export function useCompanies() {
  const [companies, setCompanies] = useState<Company[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchCompanies = async () => {
    try {
      const { data, error: fetchError } = await supabase
        .from('nrm_companies')
        .select('*')
        .order('name');

      if (fetchError) throw fetchError;
      setCompanies(data || []);
    } catch (err) {
      setError('Failed to load companies');
      console.error('Fetch error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  return { companies, loading, error, refetch: fetchCompanies };
}